import React from "react";

const Footer = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <h4 className="footer tracking-in-expand">Product by ❤️ Midnight</h4>
    </div>
  );
};

export default Footer;
